import IImageWithTextSection from '@quicktools/shared-components/components/landingPages/ImageWithTextSection/types';
import ImageWithTextSection from '@quicktools/shared-components/components/landingPages/ImageWithTextSection/ImageWithTextSection';
import { Trans, useTranslation } from 'react-i18next';

function ImageSectionWhy() {
  const { t } = useTranslation();

  const imageSectionItems: IImageWithTextSection[] = [
    {
      title: t('landing.imageSection.3.title'),
      imageWidth: 253,
      imgSrc: 'https://cdn140.picsart.com/06350059335479530960.webp',
      imgAlt: 'jpg to png online for free',
      imageRight: true,
      children: (
        <div>
          {t('landing.imageSection.3.children.paragraph')}

          <ul style={{ marginTop: 24, marginLeft: 30 }}>
            <li>
              <Trans i18nKey={'landing.imageSection.3.children.list.0'} components={{ a: <a /> }} />
            </li>
            <li>{t('landing.imageSection.3.children.list.1')}</li>
            <li>{t('landing.imageSection.3.children.list.2')}</li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <>
      {imageSectionItems.map((props, index) => (
        <ImageWithTextSection {...props} key={index} />
      ))}
    </>
  );
}

export default ImageSectionWhy;
